import { Paper, Tooltip } from '@mui/material';
import { ContentTooltiptLearningContinuumLevelMarkingInfo } from '../../Dashboard/Assessment/Classes/MarkingClasses/ContentTooltip/ContentTooltip';
import { currentMarking, initialMarking, stepMarking } from '../LearningGrowth/Styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IconLG = ({ currentCurriculum, lc, level, findLG, size, direction = 'row' }) => {
  const width = size;
  const width2 = ['gscontinue', 'gscontinue/end'].includes(findLG?.typeGrowth) ? width - 6 : width - 3;

  return (
    <Tooltip
      arrow
      placement='right'
      title={
        <ContentTooltiptLearningContinuumLevelMarkingInfo
          lc={lc}
          level={level}
          marking={{
            ...findLG,
            markingDate: findLG.day ? new Date(findLG.day) : findLG.date
          }}
          currentCurriculum={currentCurriculum}
        />
      }
    >
      <FontAwesomeIcon
        icon={
          [
            'start/end',
            'start',
            'startdown',
            'start/enddown',
            // 'continue/start/end',
            'continue/start',
            'continue/start/continue'
          ].includes(findLG?.typeGrowth)
            ? initialMarking
            : ['end', 'enddown', 'continue/end', 'gscontinue/end', 'current', 'gsend'].includes(
                findLG?.typeGrowth
              )
            ? currentMarking
            : stepMarking
        }
        className='cursor-pointer text-right rounded-full  text-muted-foreground '
        size={'2x'}
        style={{
          zIndex: 2,
          width: width2 - 5,
          height: width2 - 5,
          transform:
            // findLG?.typeGrowth.indexOf('down') > -1 ? 'scaleY(-1) rotate(180deg)' : 'none'
            [
              'start/end',
              'start',
              'startdown',
              'start/enddown',
              'continue/start/end',
              'continue/start',
              'continue/start/continue'
            ].includes(findLG?.typeGrowth)
              ? 'none'
              : ['end', 'enddown', 'continue/end', 'gscontinue/end', 'current', 'gsend'].includes(
                  findLG?.typeGrowth
                )
              ? 'none'
              : direction === 'row'
              ? 'none'
              : 'scaleY(-1) rotate(0.25turn)'
        }}
      />
    </Tooltip>
  );
};
const PaperLG = ({ lc, gs, size, minMarking, maxMarking, currentCurriculum, level }) => {
  let color = minMarking?.secondaryColor || 'inherit';
  let backgroundColor = minMarking?.primaryColor || 'inherit';
  level.definition = gs.definition || '';
  if (lc.lastMaxLevel) {
    const prom = lc.lastMaxLevel;
    if (prom.id === gs.id) {
      backgroundColor = prom?.markingPrimaryColor;
      color = prom?.markingSecondaryColor || 'inherit';
    } else if (prom.levelPosition < level.position) {
      backgroundColor = minMarking?.primaryColor || 'inherit';
      color = minMarking?.secondaryColor || 'inherit';
    } else if (prom.levelPosition > level.position) {
      backgroundColor = maxMarking?.primaryColor || 'inherit';
      color = maxMarking?.secondaryColor || 'inherit';
    }
  }
  let minLG = 999999999999999999;
  let maxLG = 0;
  let minFLG = null;
  let maxFLG = null;
  lc.lg?.forEach((item) => {
    if (item.lcId === lc.lcId && lc.ulId === item.ulId) {
      if (item.levelPosition < minLG) {
        minLG = item.levelPosition;
        minFLG = item;
      }

      if (item.levelPosition > maxLG) {
        maxLG = item.levelPosition;
        maxFLG = item;
      }
    }
  });
  const style = {};

  if (minFLG || maxFLG) {
    if (level.position > minLG && level.position < maxLG) {
      style.borderBottom = `3px dashed var(--muted-foreground)`;
      style.position = 'absolute';
      style.bottom = `calc(${size / 2}px + 0.5rem)`;
      style.left = 0;
      style.right = 0;
    } else if (level.position === minLG && minLG !== maxLG) {
      style.borderBottom = `3px dashed var(--muted-foreground)`;
      style.position = 'absolute';
      style.bottom = `calc(${size / 2}px + 0.5rem)`;
      style.left = size / 2;
      style.right = 0;
    } else if (level.position === maxLG && minLG !== maxLG) {
      style.borderBottom = `3px dashed var(--muted-foreground)`;
      style.position = 'absolute';
      style.bottom = `calc(${size / 2}px + 0.5rem)`;
      style.left = 0;
      style.right = size / 2;
    }
  }
  let findLG = null;
  lc.lg?.forEach((l) => {
    if (l.id === gs.id) {
      findLG = l;
    }
  });

  return (
    <Paper
      className={[
        'px-2 py-2 relative flex items-center justify-center',
        gs.definition ? 'cursor-pointer' : 'bg-lines'
      ].join(' ')}
      elevation={0}
      style={{
        width: size,
        height: size,
        color,
        backgroundColor
      }}
    >
      <div style={style} />
      {gs?.id === minFLG?.id && maxFLG?.id !== minFLG?.id && (
        <div className={`flex items-center justify-center absolute inset-2`}>
          <IconLG currentCurriculum={currentCurriculum} lc={lc} level={level} findLG={findLG} size={size} />
        </div>
      )}
      {gs?.id === maxFLG?.id && (
        <div className={`flex items-center justify-center absolute inset-2`}>
          <IconLG currentCurriculum={currentCurriculum} lc={lc} level={level} findLG={findLG} size={size} />
        </div>
      )}
      {/* <div className='grid grid-cols-2'>
        <div className='col-span-full'> {level.position}</div>
        <div>{minLG}-</div>
        <div>{maxLG}</div>
      </div> */}
    </Paper>
  );
};

export default PaperLG;
